import React, { FunctionComponent } from 'react';
import { Badge, IconName } from 'rs-emd-ui-atoms';
import { ILabel } from '../../../models/common/label.model';
import { IStock, StockStatus } from '../../../models/common/stock.model';
import styles from './dtp-stock-badge-component.module.scss';

export type DTPStockBadgeType = {
  labels?: ILabel[] | null;
  stockArea?: IStock | null;
  className?: string;
};

export const DTPStockBadge: FunctionComponent<DTPStockBadgeType> = (props: DTPStockBadgeType) => {
  return (
    <div className={`${styles['dtp-stock-badge-container']} ${props.className}`}>
      <Badge
        colour={
          props.stockArea?.statusCode === StockStatus.Error || props.stockArea?.statusCode === StockStatus.StatusUnavailable
            ? 'mono'
            : 'purple'
        }
        size='small'
        icon={props.stockArea?.stockBadgeIcon as IconName}>
        {props.stockArea?.title && <p className={styles['stock-title']} dangerouslySetInnerHTML={{ __html: props.stockArea?.title }} />}
      </Badge>
    </div>
  );
};

export default DTPStockBadge;
